var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgShoppingCart = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 286,
  height: 286,
  viewBox: "0 0 286 286",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_3440_4916)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M109.398 165.339L99.0778 197.55H263.661C270.692 197.55 276.392 203.249 276.392 210.281C276.392 217.312 270.693 223.012 263.661 223.012H81.6307C77.5647 223.012 73.7434 221.069 71.347 217.785C68.9506 214.5 68.2669 210.268 69.5076 206.396L85.1509 157.57L109.398 165.339Z",
  fill: "#A9AFBF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M264.471 43.0078H61.1602L99.6422 166.829H243.741L279.71 64.5181C283.403 54.0126 275.608 43.0078 264.471 43.0078Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M75.3633 188.118C81.1548 193.824 89.0656 197.208 97.6885 197.208H99.1878L109.398 165.34L85.1509 157.571L75.3633 188.118Z",
  fill: "#4D13B7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M273.269 178.111H97.6872C92.0672 178.111 87.1125 174.426 85.4948 169.046L47.4742 42.536H12.7309C5.69932 42.536 0 36.8367 0 29.8051C0 22.7735 5.69932 17.0742 12.7309 17.0742H56.9418C62.5618 17.0742 67.516 20.7593 69.1342 26.1413L107.156 152.65H273.269C280.3 152.65 286 158.349 286 165.381C285.999 172.412 280.3 178.111 273.269 178.111Z",
  fill: "#C7CFE2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M111.726 268.926C127.703 268.926 140.656 255.973 140.656 239.995C140.656 224.017 127.703 211.064 111.726 211.064C95.7476 211.064 82.7949 224.017 82.7949 239.995C82.7949 255.973 95.7476 268.926 111.726 268.926Z",
  fill: "#353640"
}), /*#__PURE__*/React.createElement("path", {
  d: "M111.726 252.08C118.4 252.08 123.811 246.67 123.811 239.995C123.811 233.321 118.4 227.91 111.726 227.91C105.051 227.91 99.6406 233.321 99.6406 239.995C99.6406 246.67 105.051 252.08 111.726 252.08Z",
  fill: "#C7CFE2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M222.158 268.926C238.136 268.926 251.089 255.973 251.089 239.995C251.089 224.017 238.136 211.064 222.158 211.064C206.18 211.064 193.228 224.017 193.228 239.995C193.228 255.973 206.18 268.926 222.158 268.926Z",
  fill: "#353640"
}), /*#__PURE__*/React.createElement("path", {
  d: "M222.158 252.08C228.833 252.08 234.244 246.67 234.244 239.995C234.244 233.321 228.833 227.91 222.158 227.91C215.484 227.91 210.073 233.321 210.073 239.995C210.073 246.67 215.484 252.08 222.158 252.08Z",
  fill: "#C7CFE2"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_3440_4916"
}, /*#__PURE__*/React.createElement("rect", {
  width: 286,
  height: 286,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShoppingCart, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/shopping-cart.727e35d3.svg";
export { ForwardRef as ReactComponent };